import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import PATHS from '@/common/paths';

interface CardActivationProps {
  alternateAccountId?: string;
  memberSequenceIdentifier?: number;
  tokenCardId?: string;
}

export const useCardActivationQuery = (props: CardActivationProps) => {
  const { alternateAccountId, memberSequenceIdentifier, tokenCardId } = props;

  const { mutateAsync, isLoading, status } = useMutation(() =>
    api.post(
      `${
        PATHS.FISERV_CARD_ACTIVATION
      }?alternate_account_id=${alternateAccountId}&member_sequence_identifier=${memberSequenceIdentifier}${
        tokenCardId ? `&token_card_id=${tokenCardId}` : ''
      }`
    )
  );

  const handleActivate = async () => {
    if (!alternateAccountId || !memberSequenceIdentifier) return;
    await mutateAsync();
  };

  return {
    handleActivate,
    isLoading,
    status,
  };
};
